import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarDays, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { countdownLabel } from "@/components/fairs/FairCard";

/** Ana sayfa: yaklaşan tarım & hayvancılık fuarları şeridi. */
export const UpcomingFairsStrip = () => {
  const { user } = useAuth();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/fairs/upcoming", { params: { limit: 6, province: user?.province || undefined } })
      .then((r) => setItems(r.data.items || [])).catch(() => {});
  }, [user]);

  if (!items.length) return null;

  return (
    <section className="mx-auto max-w-7xl px-4 py-10" data-testid="home-upcoming-fairs">
      <div className="flex items-end justify-between gap-4">
        <div>
          <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-secondary">
            <CalendarDays className="h-4 w-4" /> Ciftora Fuar Takvimi
          </p>
          <h2 className="mt-2 font-display text-2xl font-extrabold text-primary">
            Yaklaşan Tarım & Hayvancılık Fuarları
          </h2>
        </div>
        <Link to="/fuarlar" data-testid="home-fairs-all"
          className="app-tap inline-flex shrink-0 items-center gap-1 text-sm font-bold text-primary hover:underline">
          Tüm Fuarları Gör <ChevronRight className="h-4 w-4" />
        </Link>
      </div>

      <div className="no-scrollbar mt-5 flex gap-3 overflow-x-auto pb-2">
        {items.map((f) => (
          <Link key={f.id} to={`/fuarlar/${f.slug}`} data-testid={`home-fair-${f.slug}`}
            className="app-tap flex w-[260px] shrink-0 flex-col gap-1 rounded-xl border border-border bg-card p-4 transition-shadow hover:shadow-md">
            <p className="text-xs font-bold uppercase text-secondary">
              {new Date(f.start_date).toLocaleDateString("tr-TR",
                { day: "numeric", month: "short" })}
              {" – "}
              {new Date(f.end_date).toLocaleDateString("tr-TR",
                { day: "numeric", month: "short" })}
            </p>
            <p className="font-display text-base font-extrabold leading-snug text-primary line-clamp-2">
              {f.name}
            </p>
            <p className="text-sm text-muted-foreground">{f.province || "Türkiye"}</p>
            <p className="mt-auto pt-2 text-xs font-bold text-primary">{countdownLabel(f)}</p>
          </Link>
        ))}
      </div>
    </section>
  );
};
